import { CommonUtilities } from 'commonUtils';
import React, { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';

export default function MechanicalRateUpsert(param: any) {

    let [MechanicalRate, setMechanicalRate] = useState<any>(param?.editDataDawer ?? []);

    const closeDrawer = () => { param.closeDrawer() }

    const onReset = () => {
        console.log(param?.editDataDawer)
        if (param?.editDataDawer) {
            MechanicalRate = param?.editDataDawer
            setMechanicalRate(MechanicalRate)
        }
    }

    const onSave = () => {
        /*systemFormatsList.saveStatusAccount(MechanicalRate).then((respond: any) => {
            CommonUtilities.showToastDawer('Account Status Saved', 'Success')
        })*/
    }

    return (<>

        <Drawer open={param.openUpsertUX} direction='right' className='react-drawer allowHscroll ' size={800}>

            <div className="pull-right ws-5 box full-height-vh " >

                <div className="ws-12 bg-blue ">
                    <h1 className="pull-left text-center mt mll">Add Mechanical Rate</h1>
                    <i className="icon-close pull-right pLarge" onClick={closeDrawer}></i>
                </div>

                <div className="box-content">
                    <div className="ws-12">
                        <div className="ws-6">
                            <div className="form-format">
                                <label className="control-label" >Format/Source Codes*</label>
                                <div className="label-entries">
                                    <select title="Choose Format/Source Codes" ng-model="mechRate.formatCode" id="systemFormatSelected" name="systemFormatSelected" required>
                                        <option value="" >Choose Format/Source Codes</option>
                                        <option value="0" label="All Formats">All Formats</option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-format">
                                <label className="control-label">Sub Format</label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Enter Sub Format" data-ng-model="mechRate.subFormat" value={MechanicalRate?.subFormat ?? ""} onChange={(e: any) => setMechanicalRate({ ...MechanicalRate, subFormat: e.target.value })} id="subFormat" name="subFormat" />
                                </div>
                            </div>
                            <div className="form-format">
                                <label className="control-label">PercRevenue</label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Enter PercRevenue" id="percRevenue" value={MechanicalRate?.percRevenue ?? ""} onChange={(e: any) => setMechanicalRate({ ...MechanicalRate, percRevenue: e.target.value })} />
                                </div>
                            </div>

                            <div className="form-format">
                                <label className="control-label" >PerMinThereafter</label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Enter PerMinThereafter" value={MechanicalRate?.PerMinThereafter ?? ""} onChange={(e: any) => setMechanicalRate({ ...MechanicalRate, PerMinThereafter: e.target.value })} id="perMinThereafter" name="perMinThereafter" />
                                </div>
                            </div>

                            <div className="form-format">
                                <label className="control-label" >PerSubscriber</label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Enter PerSubscriber" id="perSubscriber" value={MechanicalRate?.perSubscriber ?? ""} onChange={(e: any) => setMechanicalRate({ ...MechanicalRate, perSubscriber: e.target.value })} />
                                </div>
                            </div>
                            <div className="form-format">
                                <label className="control-label" >Date Up To*</label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Select a Date" name="dateUpTo" readOnly required value={MechanicalRate?.dateUpTo ?? ""} onChange={(e: any) => setMechanicalRate({ ...MechanicalRate, dateUpTo: e.target.value })} />
                                </div>
                            </div>
                        </div>

                        <div className="ws-6">

                            <div className="form-format">
                                <label className="control-label">Fixed Rate</label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Enter Fixed Rate" value={MechanicalRate?.fixedRate ?? ""} onChange={(e: any) => setMechanicalRate({ ...MechanicalRate, fixedRate: e.target.value })} id="fixedRate" name="fixedRate" />
                                </div>
                            </div>
                            <div className="form-format">
                                <label className="control-label">Exch Rate</label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Enter ExchRate" id="exchRate" value={MechanicalRate?.exchRate ?? ""} onChange={(e: any) => setMechanicalRate({ ...MechanicalRate, exchRate: e.target.value })} />
                                </div>
                            </div>
                            <div className="form-format">
                                <label className="control-label">Home Rate1</label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Enter Home Rate1" id="homeRate1" value={MechanicalRate?.homeRate1 ?? ""} onChange={(e: any) => setMechanicalRate({ ...MechanicalRate, homeRate1: e.target.value })} />
                                </div>
                            </div>
                            <div className="form-format">
                                <label className="control-label" >Home Rate2</label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Enter Home Rate2" id="homeRate2" value={MechanicalRate?.homeRate2 ?? ""} onChange={(e: any) => setMechanicalRate({ ...MechanicalRate, homeRate2: e.target.value })} />
                                </div>
                            </div>
                            <div className="form-format">
                                <label className="control-label">Zone*</label>
                                <div className="label-entries">
                                    <select id="frmMechRate.zoneID" name="zoneID" value={MechanicalRate?.zoneID ?? ""} onChange={(e: any) => setMechanicalRate({ ...MechanicalRate, zoneID: e.target.value })} >
                                        <option value="" >Choose a zone</option>
                                        <option value="0" label="US">US</option>
                                        <option value="1" label="CA">CA</option>
                                        <option value="2" label="UK">UK</option>
                                        <option value="3" label="MX">MX</option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-format">
                                <label className="control-label" >Rate Based on*</label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Enter Rate Based on" value={MechanicalRate?.rateBasedon ?? ""} onChange={(e: any) => setMechanicalRate({ ...MechanicalRate, rateBasedon: e.target.value })} id="rateBasedon" required name="rateBasedon" />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                {/* Footer */}
                <div className="box-footer ws-12 pull-right">
                    <button type="button" className="icon-btn delete pull-right" onClick={closeDrawer}>x Close</button>
                    <button type="button" className="icon-btn delete pull-right" onClick={onReset}>↻ Reset</button>
                    <button type="button" className="icon-btn edit pull-right" onClick={onSave}>✔ Save </button>
                </div>
            </div>

        </Drawer>
    </>)
}